module.exports = __webpack_public_path__ + "/content/shared/img/bentley/email-bentley-direct-weekly-sale-ending-soon.png";